import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { customStyles, customTheme } from './styles';
import ReactSelect from 'react-select';

const Select = ({
  label,
  ...props
}) => {
  return (
    <Fragment>
      { label &&
        <div style={{ marginBottom: 8 }}>
          <span className='create-schedule-label'>{label}</span>
        </div>
      }
      <ReactSelect
        {...props}
        components={{ IndicatorSeparator: null, ...props.components }}
        styles={customStyles}
        theme={customTheme}
      />
    </Fragment>
  );
};

Select.propTypes = {
  label: PropTypes.string
};

export default Select;
